import { FC } from "react";

import './Loader.scss';


const Loader: FC = () => {

	return (
		<div className="Loader"/>
	)
}

export default Loader;